"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6511],{

/***/ 96321:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/clock.b30d2d16.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAG1BMVEUaoYZMaXEaoYYaoYYaoYYaoYYaoYYaoYYaoYaRdehPAAAACXRSTlNwAEsYgiQMAjozGGDOAAAACXBIWXMAACE4AAAhOAFFljFgAAAAMUlEQVQImR2LyQ3AQAyEwGf/HW+ckUB8Btd/rA2h2BVBiGRjzcVWkxh4nAvmwsnv/gAS+QCCJA2ouwAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 74939:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/pin.0b606da5.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAGFBMVEVMaXFUVFRUVFRUVFRUVFRUVFRUVFRUVFTKrMONAAAACHRSTlMAg0kYWDBnaULew2gAAAAJcEhZcwAAITgAACE4AUWWMWAAAAAuSURBVAiZRYrJDQAgEISY2cP+OzauMfLhAfCJXjWWrQCckhOodqZPU4XurVkeGw2XAFa9+KH7AAAAAElFTkSuQmCC"});

/***/ }),

/***/ 77652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ ActiveTag; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17471);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1__);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  inline-block\n  px-2\n  py-[5px]\n  rounded\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-bold\n  text-xs\n  uppercase\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var TagContainer = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject(), function(param) {
    var $active = param.$active;
    return $active ? 'bg-green-100' : 'bg-red-100';
});
var TagTitle = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1___default().p(_templateObject1(), function(param) {
    var $active = param.$active;
    return $active ? 'text-green-500 animate-pulse' : 'text-red-500';
});
var ActiveTag = function(_param) {
    var title = _param.title, active = _param.active, props = _objectWithoutProperties(_param, [
        "title",
        "active"
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TagContainer, _objectSpread({
        $active: active
    }, props, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TagTitle, {
            $active: active,
            children: title
        })
    })));
};



/***/ }),

/***/ 38839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ CreateBid; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(33052);
// EXTERNAL MODULE: ../graphql/src/generated/index.ts + 11 modules
var generated = __webpack_require__(63575);
// EXTERNAL MODULE: ../core/src/components/Forms/Form.tsx
var Form = __webpack_require__(48375);
// EXTERNAL MODULE: ../core/src/components/Button.tsx
var Button = __webpack_require__(36573);
// EXTERNAL MODULE: ../core/src/components/Inputs/Switch.tsx
var Switch = __webpack_require__(44147);
// EXTERNAL MODULE: ../core/src/components/Inputs/TextInput.tsx
var TextInput = __webpack_require__(10809);
// EXTERNAL MODULE: ../core/src/components/SvgIcon.tsx
var SvgIcon = __webpack_require__(16283);
// EXTERNAL MODULE: ../core/src/utils/index.ts
var utils = __webpack_require__(75920);
;// CONCATENATED MODULE: ../assets/icons/bid-price.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgBidPrice = function SvgBidPrice(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M9.994 20c1.37 0 2.658-.26 3.864-.78a10.11 10.11 0 0 0 3.188-2.17c.921-.924 1.643-1.99 2.168-3.196A9.561 9.561 0 0 0 20 10a9.562 9.562 0 0 0-.786-3.854A10.276 10.276 0 0 0 17.04 2.95 10.181 10.181 0 0 0 13.845.781 9.642 9.642 0 0 0 9.981 0C8.62 0 7.335.26 6.13.78a10.036 10.036 0 0 0-3.183 2.17 10.384 10.384 0 0 0-2.16 3.196A9.562 9.562 0 0 0 0 10c0 1.363.262 2.648.786 3.854a10.33 10.33 0 0 0 2.168 3.197 10.11 10.11 0 0 0 3.188 2.168A9.61 9.61 0 0 0 9.994 20Zm0-1.884a7.95 7.95 0 0 1-3.152-.625 8.043 8.043 0 0 1-2.576-1.741 8.153 8.153 0 0 1-1.733-2.59A8.009 8.009 0 0 1 1.907 10a8.078 8.078 0 0 1 2.347-5.75A8.043 8.043 0 0 1 6.83 2.51a7.95 7.95 0 0 1 3.151-.626c1.132 0 2.186.208 3.165.625a8.116 8.116 0 0 1 2.582 1.741 8.189 8.189 0 0 1 1.746 2.59c.42.983.631 2.037.631 3.16a8.01 8.01 0 0 1-.625 3.16 8.155 8.155 0 0 1-1.734 2.59 8.026 8.026 0 0 1-5.752 2.367Zm1.4-3.333c.255 0 .48-.014.674-.043.194-.03.357-.072.49-.13.28-.133.42-.335.42-.607a.554.554 0 0 0-.18-.434.67.67 0 0 0-.464-.161c-.107 0-.241.01-.402.03-.161.021-.345.032-.551.032-.702 0-1.315-.17-1.84-.508-.523-.34-.897-.847-1.12-1.525h3.01a.493.493 0 0 0 .37-.154c.1-.104.15-.23.15-.378 0-.347-.174-.52-.52-.52H8.21c0-.059-.003-.119-.007-.18a2.89 2.89 0 0 1 0-.41c.004-.07.007-.138.007-.204h3.22a.493.493 0 0 0 .37-.155c.1-.103.15-.229.15-.378 0-.355-.174-.533-.52-.533H8.445c.223-.652.594-1.144 1.114-1.474.52-.33 1.127-.496 1.82-.496.207 0 .39.01.552.031.16.02.295.031.402.031a.67.67 0 0 0 .465-.161.554.554 0 0 0 .18-.434.746.746 0 0 0-.087-.36c-.058-.106-.178-.201-.36-.284a1.963 1.963 0 0 0-.464-.112 5.209 5.209 0 0 0-.675-.037c-1.04 0-1.975.275-2.805.824-.83.55-1.385 1.374-1.665 2.472H5.87a.51.51 0 0 0-.365.15.509.509 0 0 0-.155.383c0 .149.051.275.155.378a.5.5 0 0 0 .365.155h.904a1.55 1.55 0 0 0-.012.192V10c0 .083.002.159.006.23.004.07.006.121.006.154H5.87a.522.522 0 0 0-.365.143.49.49 0 0 0-.155.378c0 .148.051.274.155.378a.5.5 0 0 0 .365.154h1.04c.28 1.116.834 1.952 1.66 2.51.825.557 1.766.836 2.823.836Z",
    fill: "#999"
  })));
};

/* harmony default export */ var bid_price = (SvgBidPrice);
;// CONCATENATED MODULE: ../core/src/components/Forms/CreateBid.tsx













function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var defaultValues = {
    price: '',
    autoBid: false
};
var CreateBid = function(param1) {
    var auction = param1.auction;
    var t = (0,esm/* useTranslation */.$G)('auctions').t;
    var ref5 = _slicedToArray((0,generated/* useCreateBidMutation */.LXp)(), 1), createBidMutation = ref5[0];
    var ref1 = _slicedToArray((0,generated/* useCreateAutoBidMutation */.oCZ)(), 1), createAutoBidMutation = ref1[0];
    var form = (0,index_esm/* useForm */.cI)({
        defaultValues: defaultValues
    });
    var register = form.register, watch = form.watch, getValues = form.getValues, setValue = form.setValue, setError = form.setError;
    var autoBid1 = watch('autoBid');
    var minimumBidPrice = autoBid1 ? auction.nextMinimumAutoBidPrice : auction.nextMinimumBidPrice;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(param) {
            var price, autoBid, variables, priceErrors, ref, ref2, data, priceError, ref3, ref4, data1, priceError1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        price = param.price, autoBid = param.autoBid;
                        variables = {
                            input: {
                                auction: {
                                    id: auction.id
                                },
                                price: price
                            }
                        };
                        ;
                        if (!autoBid) {
                            _ctx.next = 12;
                            break;
                        }
                        ;
                        _ctx.next = 7;
                        return createAutoBidMutation({
                            variables: variables
                        });
                    case 7:
                        data = _ctx.sent.data;
                        priceError = data === null || data === void 0 ? void 0 : (ref = data.createAutoBid) === null || ref === void 0 ? void 0 : (ref2 = ref.error) === null || ref2 === void 0 ? void 0 : ref2.price;
                        if (priceError) {
                            priceErrors = (0,utils/* getErrorTranslations */.Hm)('CreateAutoBidPriceError', priceError);
                        }
                        _ctx.next = 18;
                        break;
                    case 12:
                        ;
                        _ctx.next = 15;
                        return createBidMutation({
                            variables: variables
                        });
                    case 15:
                        data1 = _ctx.sent.data;
                        priceError1 = data1 === null || data1 === void 0 ? void 0 : (ref3 = data1.createBid) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.error) === null || ref4 === void 0 ? void 0 : ref4.price;
                        if (priceError1) {
                            priceErrors = (0,utils/* getErrorTranslations */.Hm)('CreateBidPriceError', priceError1);
                        }
                    case 18:
                        if (!priceErrors) {
                            _ctx.next = 20;
                            break;
                        }
                        return _ctx.abrupt("return", setError('price', priceErrors));
                    case 20:
                        setValue('price', (parseFloat(price) + parseFloat(auction.bidIncrement.amount)).toFixed(1));
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        auction,
        createAutoBidMutation,
        createBidMutation,
        setError,
        setValue
    ]);
    (0,react.useEffect)(function() {
        var price = getValues('price');
        if (!price || price === auction.nextMinimumAutoBidPrice.amount || price === auction.nextMinimumBidPrice.amount) {
            setValue('price', minimumBidPrice.amount);
        }
    }, [
        auction,
        minimumBidPrice,
        getValues,
        setValue
    ]);
    var bidStep = (0,utils/* formatMoney */.lb)(auction.bidIncrement);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, _objectSpread({}, form, {
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, _objectSpread({
                label: t('yourBid'),
                type: "number",
                step: auction.bidIncrement.amount,
                min: minimumBidPrice.amount,
                hint: t('minBidPrice', {
                    nextMinimumBidPrice: (0,utils/* formatMoney */.lb)(minimumBidPrice),
                    step: bidStep
                }),
                prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* SvgIcon */.l, {
                    src: bid_price,
                    size: 20
                }),
                className: "mb-6"
            }, register('price'))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch/* Switch */.r, _objectSpread({
                title: t('autoBidTitle'),
                hint: t('autoBidHint', {
                    bidStep: bidStep
                }),
                className: "mb-6"
            }, register('autoBid'))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                title: t('bid'),
                value: autoBid1 ? 'autobid-form' : 'bid-form',
                className: "w-full",
                type: "submit"
            })
        ]
    })));
};


/***/ }),

/***/ 44147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Switch; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17471);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63964);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46487);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_4__);





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex\n  flex-1\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "flex flex-col flex-1"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  text-sm\n  text-gray-800\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "text-sm text-gray-700"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "relative inline-block mr-3 w-[40px] h-[24px]"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  flex\n  cursor-pointer\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "w-0 h-0 opacity-0"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: ",
        ";\n  transition: 0.3s;\n  border-radius: 24px;\n\n  &:before {\n    position: absolute;\n    content: '';\n    height: 18px;\n    width: 18px;\n    left: 3px;\n    bottom: 3px;\n    background-color: ",
        ";\n    transition: 0.3s;\n    border-radius: 50%;\n  }\n\n  input:checked + & {\n    background-color: ",
        ";\n  }\n\n  input:checked + &:before {\n    transform: translateX(16px);\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
var Container = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default().div(_templateObject());
var LabelContainer = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default().div(_templateObject1());
var Title = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default().p(_templateObject2(), function(param) {
    var $hint = param.$hint;
    return $hint ? 'mb-1' : '';
});
var Hint = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default().p(_templateObject3());
var Handle = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default().span(_templateObject4());
var Label = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default().label(_templateObject5(), function(param) {
    var $centered = param.$centered;
    return $centered ? '' : 'items-center';
});
var Input = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default().input(_templateObject6());
var Span = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-a89df19e-0"
})(_templateObject7(), (_config__WEBPACK_IMPORTED_MODULE_4___default().colors.gray[400]), (_config__WEBPACK_IMPORTED_MODULE_4___default().colors.white), (_config__WEBPACK_IMPORTED_MODULE_4___default().colors.green[500]));
var Switch = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var title = _param.title, hint = _param.hint, className = _param.className, props = _objectWithoutProperties(_param, [
        "title",
        "hint",
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Container, {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Label, {
            $centered: hint,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Handle, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Input, _objectSpread({
                            type: "checkbox",
                            ref: ref
                        }, props)),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Span, {})
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(LabelContainer, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                            $hint: hint,
                            children: title
                        }),
                        hint && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Hint, {
                            children: hint
                        })
                    ]
                })
            ]
        })
    });
});



/***/ })

}]);